import IntlTelInput from 'intl-tel-input/react';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/styles';
import { FormikProps } from 'formik';
import { ObjStrKeyStrVal, TextInputInterface } from '../types';

type PhoneFieldProps = TextInputInterface & {
  formik: FormikProps<ObjStrKeyStrVal>;
};

const INTL_PH_UTILITY_SCRIPT = `https://cdn.jsdelivr.net/npm/intl-tel-input@${intlTelInput.version}/build/js/utils.js`;
const DEFAULT_COUNTRY = 'us';

const LpePhoneField = ({
  formik,
  isTouchedAndError,
  field,
  textFieldClassNames,
}: PhoneFieldProps) => {
  const hasError = isTouchedAndError || !!formik.errors[field.parameterName];
  const errorClass = hasError ? 'errorBorder' : '';

  const handlePhNumChange = (value: string) => {
    if (!formik.touched[field.parameterName] && value.length > 0) {
      formik.setFieldTouched(field.parameterName, true, false);
    }
    if (formik.touched[field.parameterName] && value.length === 0) {
      formik.setFieldTouched(field.parameterName, false, false);
    }
    formik.values['phone'] = value;
  };

  const handlePhNumValidate = (valid: boolean) => {
    const ValidPh = formik.isValid || valid;
    if (
      ValidPh &&
      formik.touched[field.parameterName] &&
      formik.errors[field.parameterName]
    ) {
      formik.setFieldError(field.parameterName, '');
    }
    if (
      !ValidPh &&
      formik.touched[field.parameterName] &&
      !formik.errors[field.parameterName]
    ) {
      formik.setFieldError(field.parameterName, 'Invalid phone number');
    }
  };

  return (
    <IntlTelInput
      onChangeNumber={handlePhNumChange}
      onChangeValidity={handlePhNumValidate}
      initOptions={{
        loadUtilsOnInit: INTL_PH_UTILITY_SCRIPT,
        strictMode: true,
        autoPlaceholder: 'polite',
        initialCountry: DEFAULT_COUNTRY,
        countryOrder: [DEFAULT_COUNTRY, 'ca', 'gb'],
        containerClass: 'intlTelInput',
        placeholderNumberType: 'FIXED_LINE',
        formatAsYouType: true,
        formatOnDisplay: true,
        fixDropdownWidth: true,
        nationalMode: true,
        validationNumberType: 'MOBILE',
      }}
      inputProps={{
        id: field.parameterName,
        className: `iti__tel-input ${textFieldClassNames.mainField} ${errorClass}`,
        'aria-label': 'Phone Number',
        'aria-required': true,
        'aria-invalid': hasError,
      }}
    />
  );
};

export default LpePhoneField;
